import { Phone, MessageSquare, Mail, RefreshCw } from 'lucide-react';

export const TASK_TYPES = {
  call: { label: 'Call', icon: Phone, color: 'text-blue-600 bg-blue-50' },
  text: { label: 'Text', icon: MessageSquare, color: 'text-emerald-600 bg-emerald-50' },
  email: { label: 'Email', icon: Mail, color: 'text-purple-600 bg-purple-50' },
  follow_up: { label: 'Follow-up', icon: RefreshCw, color: 'text-amber-600 bg-amber-50' },
};

const endOfToday = () => { const d = new Date(); d.setHours(23, 59, 59, 999); return d; };

export const taskBucket = (t) => {
  if (t.done) return 'done';
  const due = new Date(t.due_at);
  if (due < new Date()) return 'overdue';
  if (due <= endOfToday()) return 'today';
  return 'upcoming';
};

export const formatDue = (iso) => {
  const d = new Date(iso);
  const today = new Date();
  const tomorrow = new Date(); tomorrow.setDate(today.getDate() + 1);
  const time = d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  if (d.toDateString() === today.toDateString()) return `Today ${time}`;
  if (d.toDateString() === tomorrow.toDateString()) return `Tomorrow ${time}`;
  return `${d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })} ${time}`;
};

export const toLocalInput = (iso) => {
  const d = iso ? new Date(iso) : new Date(Date.now() + 3600000);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
